import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import storeLoader from 'app/stores/storeLoader';
import AgentsOverview from 'app/views/synthetics/components/dashboard/AgentsOverview';
import WidgetFrame from '../WidgetFrame';

@storeLoader('$syn.tests', '$syn.agents')
@inject('$syn')
@observer
class AgentsOverviewWidget extends Component {
  render() {
    const { canCustomize, onRemove, ...props } = this.props;

    return (
      <WidgetFrame canCustomize={canCustomize} onRemove={onRemove} title="Agents by Status" {...props}>
        <AgentsOverview isWidgetView />
      </WidgetFrame>
    );
  }
}

export default AgentsOverviewWidget;
